import { css } from '@emotion/react'
import { HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import error404Image from 'images/404-notfound.webp'
import errorGenericImage from 'images/error.webp'

import { HeaderPainelChamada } from './HeaderPainelChamada'

type ErrorVariant = 'generic' | 'unavailable'

interface PainelChamadasErrorViewProps {
  title: string
  description?: string
  variant?: ErrorVariant
}

const IMAGE_MAP: Record<ErrorVariant, string> = {
  generic: errorGenericImage,
  unavailable: error404Image,
}

export function PainelChamadasErrorView(props: Readonly<PainelChamadasErrorViewProps>) {
  const { title, description, variant = 'generic' } = props
  const theme = useTheme()
  const styles = createStyles(theme)
  const selectedImage = IMAGE_MAP[variant]

  return (
    <div css={styles.wrapper}>
      <HeaderPainelChamada variant='light' />
      <HFlow style={styles.contentArea} alignItems='center' justifyContent='space-around'>
        <VFlow vSpacing={0.5} style={styles.errorText}>
          <Text variant='h1' color='inherit'>
            {title}
          </Text>
          {description && (
            <Text variant='h3' fontWeight='normal' color='inherit'>
              {description}
            </Text>
          )}
        </VFlow>
        <img css={styles.image} src={selectedImage} alt='Ilustração de erro' />
      </HFlow>
    </div>
  )
}

const createStyles = (theme: Theme) => {
  return {
    wrapper: css`
      flex: 1;
      background-color: ${theme.pallete.gray.c90};
      color: ${theme.pallete.primary.c30};
      padding: 2rem 2.5rem 2.625rem;
      display: flex;
      flex-direction: column;
    `,
    contentArea: css`
      flex-grow: 1;
    `,
    image: css`
      max-height: 20rem;
    `,
    errorText: css`
      color: ${theme.pallete.gray.c10};
      max-width: 25rem;
    `,
  }
}
